/**
 * Mapeamento de get & set para propriedades de um objecto na Vuex Store.
 * @param {Array} fields # Propriedades do objecto a mapear.
 * @param {String} [namespace] - Namespace do Modulo.
 * @param {String} [getter] - Nome personalizado do Getter.
 * @param {String} [action] - Nome personalizado do Action.
 * @param {Object}
 */
export const mapFields = (fields, namespace = '', getter = 'mapGetter', action = 'mapAction') => {
    const obj = {}
    for(var i = 0; i< fields.length; i++){
        const key = fields[i]
        const getterKey = (namespace.length > 0 ? namespace + '/' : '') + getter
        const actionKey = (namespace.length > 0 ? namespace + '/' : '') + action
        const field = {
            get(){
                return this.$store.getters[getterKey](key)
            },
            set(value){
                this.$store.dispatch({
                    type: actionKey,
                    payload: {
                        prop: key,
                        value: value
                    }
                })
            }
        }
        obj[key] = field
    }
    return obj
}
/**
 * Mapeamento de getters para propriedades de um objecto na Vuex Store.
 * @param {String} path - Nome do Objecto.
 * @param {String} [name] - Nome personalizado do Getter.
 * @param {Function} [modifier] - Funcão de Modificação do valor.
 * @param {Object}
 */
export const mapGetters = (path, name = 'mapGetter', modifier = undefined) => {
    const obj = {}
    if(modifier){
        obj[name] = (state) => {
            return prop => modifier(state[path][prop])
        }
    }else{
        obj[name] = (state) => {
            return prop => state[path][prop]
        }
    }
    return obj
}
/**
 * Mapeamento de actions para propriedades de um objecto na Vuex Store.
 * @param {String} [name] - Nome personalizado da Action.
 * @param {String} [mutation] - Nome personalizado da Mutation. null cancela a execução da Mutation.
 * @param {Function} [pre_plugin] - Plugin para execução anterior à Mutation. {prop: {Nome Propriedade do Objecto}, value: {Nome Propriedade do Objecto}}
 * @param {Function} [aft_plugin] - Plugin para execução posterior à Mutation. {prop: {Nome Propriedade do Objecto}, value: {Nome Propriedade do Objecto}}
 * @param {Object}
 */
export const mapActions = (name = 'mapAction', mutation = 'mapMutation', pre_plugin = undefined, aft_plugin = undefined) => {
    const obj = {}
    obj[name] = (context, payload) => {
        if(pre_plugin){
            pre_plugin(payload.payload)
        }
        if(mutation){
            context.commit(mutation, payload.payload)
        }
        if(aft_plugin){
            aft_plugin(payload.payload)
        }
    }
    return obj
}
/**
 * Mapeamento de mutations para propriedades de um objecto na Vuex Store.
 * @param {String} path - Nome do Objecto.
 * @param {String} [name] - Nome personalizado da Mutation.
 * @param {Object}
 */
export const mapMutations = (path, name = 'mapMutation') => {
    const obj = {}
    obj[name] = (state, payload) => {
        state[path][payload.prop] = payload.value
        // Vue.set(state[path], payload.prop, value)
        // const obj = {}
        // obj[payload.prop] = payload.value
        // state[path] = Object.assign(state[path], obj)
        // state.key = Date.toString()
    }
    return obj
}


// WEBPACK FOOTER //
// ./resources/js/modules/orcamento/lib.js